import { Fancybox } from "../libs/fancybox.umd";

export const fancyboxGalleryInit = () => {
  Fancybox.bind('[data-fancybox="gallery"]', {
    Image: {
      zoom: false,
    },
    Toolbar : {
      display:[
        'close'
      ]
    }
  });
}